import React from 'react';
import PropTypes from 'prop-types';
import styles from './Card.module.scss';
import classNames from 'classnames';

const Card = (props) => {
  return (
    <div
      onClick={!props.disabled ? props.onClick : () => null}
      id={props.id}
      className={classNames(styles.container, props.extraClass, {
        [styles.selected]: props.selected,
        [styles.disabled]: props.disabled,
        [styles.noPointer]: props.noPointer
      })}
      style={props.extraStyle}
    >
      {props.image ? (
        <img className={styles.image} src={props.image} alt="" />
      ) : props.scrollable ? (
        <div className={styles.wrapper}>{props.children}</div>
      ) : (
        props.children
      )}
    </div>
  );
};

Card.propTypes = {
  id: PropTypes.string,
  extraClass: PropTypes.string,
  extraStyle: PropTypes.object,
  onClick: PropTypes.func,
  scrollable: PropTypes.bool,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  noPointer: PropTypes.bool,
  image: PropTypes.string,
  children: PropTypes.node
};

export default Card;
